import { computed } from "vue";
import "./index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./index-BNd8MWnO.js";
import "./index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { u as useVModel } from "./index-BJV0_gaH.js";
import { m as model, e as emits } from "./SingleInput-CTOYPcHF.js";
import XCheckbox from "../XCheckbox.js";
import { X as XIcon } from "./XIcon-U9bwokTN.js";
import { u as useHeightProps } from "./index-BWUsUM8p.js";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-VvYS6rEj.js";
const { createHeightProps } = useHeightProps();
const { createTestIdProp } = useDataTestIdProp();
const { createVModelProp } = useVModel();
const ROW_HEIGHT = "5.6rem";
function useProps() {
  const globalProps2 = {
    loading: {
      type: Boolean,
      default: false
    },
    checkable: {
      type: Boolean,
      default: false
    },
    ...createTestIdProp()
  };
  const rowProps = {
    maxRowLines: {
      type: Number,
      default: 1
    },
    ...createHeightProps({
      height: ROW_HEIGHT
    })
  };
  const firstColumnProps2 = {
    checked: {
      type: [String, Number, Boolean, Array, Object],
      default: false
    },
    canShowIconSpace: {
      type: Boolean,
      default: false
    },
    ...createVModelProp([Boolean, Array, String], false)
  };
  return {
    globalProps: globalProps2,
    rowProps,
    firstColumnProps: firstColumnProps2
  };
}
const firstColumn = "_firstColumn_1s3dt_1";
const style0 = {
  firstColumn
};
const { setupTestId } = useDataTestIdProp();
const { setupVModel } = useVModel();
const { globalProps, firstColumnProps } = useProps();
const __default__ = {
  name: "FirstColumn",
  components: {
    XIcon,
    XCheckbox
  },
  model
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    role: {
      type: String,
      default: "cell"
    },
    ...globalProps,
    ...firstColumnProps
  },
  emits: ["select:item", ...emits],
  setup(__props, { emit }) {
    const props = __props;
    const { data: isChecked } = setupVModel(props, emit);
    const { formatTestId } = setupTestId(props);
    const isValidIcon = computed(() => {
      var _a, _b;
      return (_b = (_a = props.item) == null ? void 0 : _a.icon) == null ? void 0 : _b.name;
    });
    const invisibleIcon = {
      name: "chevron-right"
    };
    const iconProps = computed(() => {
      var _a, _b, _c, _d;
      return {
        icon: ((_b = (_a = props.item) == null ? void 0 : _a.icon) == null ? void 0 : _b.name) || invisibleIcon.name,
        iconStyle: ((_d = (_c = props.item) == null ? void 0 : _c.icon) == null ? void 0 : _d.style) || "fal",
        fixedWidth: true
      };
    });
    const iconStyle = computed(() => {
      var _a, _b;
      return {
        visibility: isValidIcon.value ? "visible" : "hidden",
        fontColor: ((_b = (_a = props.item) == null ? void 0 : _a.icon) == null ? void 0 : _b.color) || "currentColor"
      };
    });
    const rawItem = computed(() => {
      var _a;
      return ((_a = props.item) == null ? void 0 : _a._raw) ?? props.item;
    });
    return { __sfc: true, setupTestId, setupVModel, globalProps, firstColumnProps, props, emit, isChecked, formatTestId, isValidIcon, invisibleIcon, iconProps, iconStyle, rawItem, XCheckbox, XIcon };
  }
});
var _sfc_render = function render() {
  var _a;
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return !_vm.loading && (_vm.canShowIconSpace || _vm.checkable) ? _c("div", { class: _vm.$style.firstColumn, attrs: { "role": _vm.role } }, [_vm.checkable ? _c(_setup.XCheckbox, { attrs: { "disabled": (_a = _vm.item) == null ? void 0 : _a.disabled, "data-testid": _setup.formatTestId("checkbox"), "name": "table-row", "value": _setup.rawItem }, model: { value: _setup.isChecked, callback: function($$v) {
    _setup.isChecked = $$v;
  }, expression: "isChecked" } }) : _vm._e(), _vm.canShowIconSpace ? _c(_setup.XIcon, _vm._b({ class: _vm.$style.icon, style: _setup.iconStyle }, "XIcon", _setup.iconProps, false)) : _vm._e()], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const FirstColumn = __component__.exports;
export {
  FirstColumn as F,
  useProps as u
};
